import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { WindowService } from '@core/services/window.service';

export const CheckoutGuard: CanActivateFn = () => {
  const windowService = inject(WindowService);
  return windowService.init();
};
